<template>
  <v-dialog max-width="500">
    <template #default="{ isActive }">
      <v-card>
        <template #title>
          <span class="text-primary">{{ t("components.companies.newCompany.title") }}</span>
        </template>
        <template #text>
          <p>{{ t("components.companies.newCompany.description") }}</p>
          <br />
          <p>{{ t("components.companies.newCompany.onboardingNote") }}</p>
          <br />
          <p>{{ t("components.companies.newCompany.confirmation") }}</p>
        </template>
        <template #actions>
          <v-btn-nd :text="t('form.cancel')" class="ms-4 my-4" @click="isActive.value = false" />
          <v-spacer />
          <v-btn
            :text="t('form.start')"
            to="/onboarding"
            class="me-4 my-4 bg-primary on-primary"
            @click="merchantsStore.startNewMerchant"
          />
        </template>
      </v-card>
    </template>
  </v-dialog>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { useMerchantsStore } from "@/store/merchants";

const { t } = useI18n();
const merchantsStore = useMerchantsStore();
</script>
